import { t } from 'shared/locale/texts';
import type { HotelRoom } from '../types/HotelRoom';

export const formatRoomInfoText = (rooms: HotelRoom[]): string => {
    const roomsText = t('hotel.room.amount', { count: rooms.length });
    const adultCount = rooms.reduce((acc, r) => acc + r.adults, 0);
    const childrenCount = rooms.reduce((acc, r) => acc + r.children.length, 0);
    const travellersText = t('flight.passengers.traveller', {
        count: adultCount + childrenCount,
    });

    return t('hotel.room.infoTravellers', { travellersText, roomsText });
};
